import styled, { keyframes } from "styled-components";
import { Info } from "lucide-react";

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e9eaeb;
  border-radius: 12px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  background: #fff;
  width: 100%;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #ffffff;
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 20px;
`;

export const ShowMoreButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #535862;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }
  &:active:not(:disabled) {
    opacity: 0.6;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e9eaeb;
`;

export const KeyStatsContainer = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;

  > div {
    display: flex;
    flex-direction: column;
    min-width: 120px;
    /* PG-2492: trims the inner text rectangle so the label wraps with
       enough room left over for the info icon on the wrapping line. */
    padding-right: 16px;
  }
`;

/* ✅ New Badge style copied & adapted from HeroCard */
export const StatBadge = styled.div`
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #414651;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);

  img,
  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
  }
`;

/* PG-2492: rendered inline inside the label so it sits flush with the last
   word. vertical-align lines the SVG up with the x-height of the 12px text. */
export const StatInfoIcon = styled(Info)`
  display: inline-block;
  vertical-align: -2px;
  margin-left: 4px;
  opacity: 0.6;
  cursor: help;
`;

export const NoDataMessage = styled.div`
  width: 100%;
  text-align: center;
  padding: 20px 0;
  font-size: 14px;
  color: #667085;
  font-weight: 500;
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`;

export const SkeletonItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 120px;
  gap: 6px;
`;

export const SkeletonBlock = styled.div`
  border-radius: 4px;
  background: #e0e0e0;
  background-image: linear-gradient(
    90deg,
    #e0e0e0 0px,
    #f5f5f5 40px,
    #e0e0e0 80px
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.2s infinite linear;
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "14px"};
`;
